import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';

import { Message } from '@qtek/shared/models';
import { rawMessageFallback } from '@qtek/shared/utils';

export interface WSAlertDialogInput {
  message: Message;
  title?: string;
  closeButton?: string;
  details?: Message[];
}

export const wsAlertDialogConfig: MatDialogConfig = {
  width: '600px',
  autoFocus: false,
};

@Component({
  selector: 'qt-ws-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: false,
})
export class WSAlertDialogComponent {
  data = inject<WSAlertDialogInput>(MAT_DIALOG_DATA);
  readonly rawMessageFallback = rawMessageFallback;

  constructor() {
    this.data = {
      closeButton: 'CMD_DISMISS',
      ...this.data,
    };
  }
}
